import { TimeSeriesMeasurementPoint } from '../../timeseries-statistics/model/TimeSeriesMeasurement.model';
import { Timestamp } from '../../timeseries-statistics/model/Timestamp.model';

export interface SlaMetricsMeasurementApiModel {
  time: Timestamp;
  measurement: {
    delay: number;
    jitter: number;
    lossRatio: number;
  };
}

export interface SlaMetricsMeasurementViewModel {
  time: Date[];
  delay: number[];
  jitter: number[];
  lossRatio: number[];
}

export const mapSlaMetricsMeasurementApiModelToSlaMetricsMeasurementViewModel = (
  apiMeasurements: SlaMetricsMeasurementApiModel[],
): SlaMetricsMeasurementViewModel => {
  const measurement: SlaMetricsMeasurementViewModel = {
    jitter: [],
    lossRatio: [],
    delay: [],
    time: [],
  };
  apiMeasurements.forEach(apiMeasurement => {
    measurement.delay.push(apiMeasurement.measurement.delay);
    measurement.jitter.push(apiMeasurement.measurement.jitter);
    measurement.lossRatio.push(apiMeasurement.measurement.lossRatio);
    measurement.time.push(new Date(apiMeasurement.time));
  });
  return measurement;
};

export const buildSeriesData = (
  measurement: SlaMetricsMeasurementViewModel,
  metric: 'jitter' | 'delay' | 'lossRatio'
) : TimeSeriesMeasurementPoint[] =>
  measurement.time.map((time, index) => ({
    x: time.getTime(),
    y: measurement[metric][index]
  }));